{
    "component-card-search-list.empty-state.title.non-final": "<strong>Ezt az adattárat hozzákapcsolja egy szoftverkomponenshez</strong>",
    "component-card.add-chat-channel": "Csevegőcsatorna hozzáadása",
    "component-card.chat-channels": "Csevegőcsatornák",
    "component-card.expander.show-more-link": "{formattedCount} további megjelenítése"
}
